import * as React from 'react'
import ReactDOM from 'react-dom/client';

import { App } from './App'
import reportWebVitals from './reportWebVitals';

// https://www.sliderrevolution.com/design/web-developer-portfolio-examples/
// https://fabianirsara.com
// https://jacekjeznach.com

// https://github.com/alan2207/bulletproof-react

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
